// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"f3cb9307","605":"407306a7","725":"a78f6569"}[chunkId] + ".chunk.js";
};